import { render, staticRenderFns } from "./MaterialCategoryList.vue?vue&type=template&id=6ac3d789&scoped=true"
import script from "./MaterialCategoryList.vue?vue&type=script&lang=js"
export * from "./MaterialCategoryList.vue?vue&type=script&lang=js"
import style0 from "./MaterialCategoryList.vue?vue&type=style&index=0&id=6ac3d789&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ac3d789",
  null
  
)

export default component.exports